<template>
  <v-container fluid fill-height style="height: 300px;">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
export default {}
</script>

<style></style>
